import { NewsItem } from '../types';

interface BackendData {
    news: any[];
    lastUpdate: number;
}

export const fetchGamingNews = async (): Promise<NewsItem[]> => {
    try {
        // --- CAMBIO CRÍTICO ---
        // 1. Ya no llamamos a localhost:5000 (eso era solo para Node.js).
        // 2. Leemos el archivo 'news_data.json' directamente.
        // 3. Agregamos '?t=' + Date.now() para evitar que el navegador guarde caché viejo (Cache Busting).
        const response = await fetch('/news_data.json?t=' + Date.now());
        
        // Si el archivo no existe (ej. es la primera vez y el PHP aun no corre)
        if (!response.ok) {
            console.warn("El archivo de noticias aún no existe o no se encuentra.");
            return [];
        }

        const data: BackendData = await response.json();

        // Validación extra por si el JSON está vacío
        if (!data || !data.news) return [];

        return data.news.map((item, index) => {
            // Limpieza del nombre de la fuente
            let sourceName = item.fuente_nombre || 'Fuente Desconocida';
            if (sourceName.includes('IGN')) sourceName = 'IGN Latinoamérica';
            if (sourceName.includes('3DJuegos')) sourceName = '3DJuegos';
            if (sourceName.includes('VidaExtra')) sourceName = 'VidaExtra';
            if (sourceName.includes('TierraGamer')) sourceName = 'TierraGamer';
            if (sourceName.includes('GamersRD')) sourceName = 'GamersRD';
            if (sourceName.includes('Vandal')) sourceName = 'Vandal';
            if (sourceName.includes('Eurogamer')) sourceName = 'Eurogamer';
            if (sourceName.includes('PlayStation')) sourceName = 'PlayStation Blog';
            if (sourceName.includes('Xbox')) sourceName = 'Xbox Wire';
            if (sourceName.includes('Nintenderos')) sourceName = 'Nintenderos';
            if (sourceName.includes('Tarreo')) sourceName = 'Tarreo';

            return {
                id: `news-${index}-${item.fecha}`, // Usamos la fecha para ID único
                title: item.titulo,
                summary: item.contenido,
                category: sourceName, // Nombre limpio de la fuente (Para la tarjeta)
                platform: item.categoria || 'General', // Categoría detectada (Para las secciones)
                imageUrl: item.imagen || 'https://images.unsplash.com/photo-1550745165-9bc0b252726f',
                date: new Date(item.fecha).toLocaleDateString('es-ES', { day: 'numeric', month: 'short', year: 'numeric' }),
                readTime: '5 min',
                sourceUrl: item.fuente_link
            };
        });
    } catch (error) {
        console.error("Error cargando noticias:", error);
        return [];
    }
};